export enum PageType {
  past = "past",
  future = "future",
  birth = "birth",
  end = "end",
}
